/**
 * Strips any absolute origin from a booking link so the browser uses the
 * current host (e.g. localhost:3000 in dev, millionspaces.com in prod).
 */
export const toRelativeBookingPath = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }

  try {
    const { pathname, search } = new URL(trimmed);
    return `${pathname}${search}`;
  } catch {
    return null;
  }
};

const hasUrlTimeParams = (url) => /(?:^|[?&])urlStartTime=/i.test(url || '');
const hasUrlDateParams = (url) => /(?:^|[?&])urlStartDate=/i.test(url || '');

/**
 * Prefer the client-built URL whenever it carries a requested date or time
 * (availability mode), so the booking page opens on the date/time the user asked
 * for. The API-provided link can snap the date to "today" when a space isn't
 * bookable on the requested date, so we only fall back to it for browse-mode
 * cards where the built URL has neither date nor time.
 */
export const resolveSpaceCardBookingUrl = (space, fallback) => {
  const built = typeof fallback === 'function' ? fallback() : null;
  const fromApi = toRelativeBookingPath(space?.bookingUrl);

  if (built && (hasUrlTimeParams(built) || hasUrlDateParams(built))) {
    return built;
  }
  if (fromApi && hasUrlTimeParams(fromApi)) {
    return fromApi;
  }
  if (built) {
    return built;
  }
  return fromApi;
};
